
import { Component, Vue } from "vue-property-decorator";
import { SMUser, SMCases } from "@/store";
import { API_ROUTES } from "@/utils/API";

const ICON_ARCHIVE = "archive-outline";

@Component({
  components: {
    ArchiveUnavailablePopup: () => import("@/components/Popups/ArchiveUnavailablePopup.vue"),
  },
})
export default class UnarchiveCandidate extends Vue {
  icon = ICON_ARCHIVE;

  get caseId(): number {
    return Number(this.$route.params.id ?? 0);
  }

  get unarchiveEndpoint(): string {
    if (!this.caseId) return "";

    if (SMUser.isExpert) return API_ROUTES.EXPERT_CASE_UNARCHIVE(this.caseId);

    if (SMUser.isEmployer) return API_ROUTES.CASE_UNARCHIVE(this.caseId);

    return "";
  }

  unarchiveLoading = false;

  async unarchiveCandidate() {
    try {
      this.unarchiveLoading = true;

      await this.axios.get(this.unarchiveEndpoint);

      SMCases.setIsArchived(false);
    } catch (e) {
      this.openUnArchivePopup();
    } finally {
      this.unarchiveLoading = false;
    }
  }

  unarchivePopup = false;

  openUnArchivePopup() {
    this.unarchivePopup = true;
  }

  closeUnArchivePopup() {
    this.unarchivePopup = false;
  }
}
